import { render, staticRenderFns } from "./PrkSpinner.vue?vue&type=template&id=68d2496c&scoped=true&"
import script from "./PrkSpinner.vue?vue&type=script&lang=js&"
export * from "./PrkSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d2496c",
  null
  
)

export default component.exports